/**
 * Normalizes a raw phone number string for WhatsApp / contact storage.
 *
 * Rules (in order):
 *  1. Falsy / non-string → ''
 *  2. Already E.164 (starts with '+') → return as-is
 *  3. Strip spaces, dashes, parens, dots; extract pure digits
 *  4. length < 10 → '' (landline or invalid — no WhatsApp)
 *  5. 13 digits matching /^977(98|97|96)\d{8}$/ (country code without '+') → '+' + digits
 *  6. 10 digits matching /^(98|97|96)\d{8}$/ (Nepal mobile without country code) → '+977' + digits
 *  7. Otherwise → return the cleaned (non-E.164) string unchanged
 */
export function normalizePhoneForWhatsApp(raw) {
  if (!raw || typeof raw !== 'string') return '';

  // Strip common separators but preserve a leading '+'
  const cleaned = raw.trim().replace(/[\s\-().]/g, '');
  if (!cleaned) return '';

  // Already E.164 — trust it as-is
  if (cleaned.startsWith('+')) return cleaned;

  // Work with pure digits
  const digits = cleaned.replace(/\D/g, '');

  // Too short to be a mobile number (landline or garbage)
  if (digits.length < 10) return '';

  // 13 digits: Nepal country code (977) already present, just missing the '+'
  if (/^977(98|97|96)\d{8}$/.test(digits)) return '+' + digits;

  // 10 digits: Nepal mobile prefix without country code
  if (/^(98|97|96)\d{8}$/.test(digits)) return '+977' + digits;

  // Unknown format — return cleaned (the caller may validate via isValidPhoneNumber)
  return cleaned;
}
